export default __webpack_public_path__ + "static/media/video-heading.png?.97215869";